import { AppState } from "../../reducers";
import { UsersState } from "./reducer";

export const usersSelector = (state: AppState): UsersState => {
  return state.users;
};
